<div @animateIn @animateOut id="on-hold-call-container" class="mat-elevation-z3" *ngIf="currentOnHoldCallDisplay">
    <div class="on-hold-options">
        <button class="on-hold-button-options" [disabled]="callStateIsProcessing" (click)="mergeCalls()">
            <span class="material-icons on-hold-call-icons">call_merge</span>
        </button>
        <button class="on-hold-button-options" [disabled]="callStateIsProcessing" (click)="swapCalls()">
            <span class="material-icons on-hold-call-icons">swap_horiz</span>
        </button>
    </div>
    <div class="on-hold-call-display-container">
        <div class="on-hold-borrower">
            <p class="on-hold-info">
                <a *ngIf="secondaryCall && secondaryCall.businessName">{{ secondaryCall.businessName }}<br/></a>
                <a *ngIf="!secondaryCall.businessName && secondaryCall.borrower && secondaryCall.borrower.primary_contact">
                    {{ secondaryCall.borrower && secondaryCall.borrower.primary_contact ? secondaryCall.borrower.primary_contact.first + ' ' + secondaryCall.borrower.primary_contact.last : 'Unknown Caller' }}<br/>
                </a>
                <a *ngIf="!secondaryCall.businessName && !secondaryCall.borrower">
                    {{ 'Unknown Caller' }}<br/>
                </a>
                <span *ngIf="secondaryCall.callId" class="tw-text-xs">{{ this.displayPhoneNumber | phone }} -
                    <span class="tw-text-xs tw-text-red-500">
                        On Hold
                    </span>
                </span>
            </p>
        </div>
    </div>
</div>
